import { createProviderToken } from '@core/common-legacy';

export type AppContextGetter = () => Record<string, unknown>;

export const {
  provide: provideTellentAssistantAppContextGetter,
  inject: injectTellentAssistantAppContextGetter,
} = createProviderToken<AppContextGetter>('TELLENT_ASSISTANT_APP_CONTEXT_GETTER')(false);
